import { render } from "./AppHeaderLinks.vue?vue&type=template&id=7f4d994b"
import script from "./AppHeaderLinks.vue?vue&type=script&lang=js"
export * from "./AppHeaderLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__